import SnippetDefinition from "./Snippet/definition";
import DatasetExamplesDefinition from "./DatasetExamples/definition";
import { ContentNodeDefinition } from "./types";

const ContentNodeDefinitions: ContentNodeDefinition[] = [
  SnippetDefinition,
  DatasetExamplesDefinition,
];

export default ContentNodeDefinitions;
